import { PageHeader } from '@repo/ui/components/page-header'
import { useSuspenseQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from '@/lib/i18n'
import { currentCallOfEach } from '../bando/-lib/current-call'
import { managedCallsQueryOptions } from '../bando/-query/query-options'
import { StructureCard } from './-components/structure-card'

export const Route = createFileRoute('/(private)/strutture/')({
	component: StructuresPage
})

/**
 * "Strutture": every residence of the facility manager, with what its data
 * still lacks. The manager completes the data here first; the call is made
 * afterwards from "Bandi", on one of these residences.
 */
function StructuresPage() {
	const { t } = useTranslation()
	const list = currentCallOfEach(
		useSuspenseQuery(managedCallsQueryOptions()).data
	)

	return (
		<main className='flex min-h-0 flex-1 flex-col gap-6 overflow-y-auto p-4 md:p-6'>
			<PageHeader title={t('admin-call:structures.page_title')} />
			<p className='max-w-3xl text-muted-foreground text-sm'>
				{t('admin-call:structures.intro')}
			</p>
			{list.length === 0 ? (
				<p className='text-muted-foreground text-sm'>
					{t('admin-call:residences.empty')}
				</p>
			) : (
				<ul className='grid gap-4 lg:grid-cols-2'>
					{list.map((item) => (
						<li key={item.residence.id}>
							<StructureCard item={item} />
						</li>
					))}
				</ul>
			)}
		</main>
	)
}
